import React from 'react';
import { Text } from '@gluestack-ui/themed';
import JustificationBadges from './JustificationBadges';
import type { DimensionCriterion } from './types';

interface EvalJustificationProps {
  justification?: string;
  dimension?: string;
  dimensionCriteria?: DimensionCriterion[];
}

/**
 * Component to display evaluation justifications
 * Can display either as plain text or as badges using JustificationBadges component
 */
const EvalJustification = ({ justification, dimension, dimensionCriteria = [] }: EvalJustificationProps) => {
  if (!justification) return null;

  // Check if the justification is in badge format (contains : and ;)
  const isBadgeFormat = justification.includes(':') && justification.split(':').length >= 3;

  // If it's in badge format and useBadges is true, use JustificationBadges
  if (isBadgeFormat) {
    return (
      <JustificationBadges justification={justification} dimension={dimension} dimensionCriteria={dimensionCriteria} />
    );
  }

  // Otherwise, display as plain text
  return <Text size="xs">{justification}</Text>;
};

export default EvalJustification;
